import { render } from "./QuestionOptionInput.vue?vue&type=template&id=4ed5d9bd&ts=true"
import script from "./QuestionOptionInput.vue?vue&type=script&lang=ts"
export * from "./QuestionOptionInput.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__